import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { PolicyTrackerData } from './policy-tracker.interfaces';

@Injectable({
  providedIn: 'root'
})
export class PolicyTrackerService {
  constructor(private http: HttpClient) {}

  getPolicyStatus(token: string): Observable<PolicyTrackerData> {
    const headers = {
      'HTTP_TIMEZONE': Intl.DateTimeFormat().resolvedOptions().timeZone
    };

    return this.http.get<PolicyTrackerData>(`/policy_tracker_by_auth_token`, {
      headers,
      params: { token }
    });
  }
}